export default "__VITE_ASSET__DRsw06bL__"